export default "__VITE_PUBLIC_ASSET__b85a378e__"